import React, { useState, useEffect } from 'react';
import { useSubscription } from './SubscriptionContext';
import { PremiumFeatureOverlay } from './PremiumFeatureOverlay';
import { SubscriptionModal } from './SubscriptionModal';
import { shouldBypassSubscription } from '../../lib/platform';

interface PremiumFeatureProps {
  children: React.ReactNode;
  featureName: string;
}

export function PremiumFeature({ children, featureName }: PremiumFeatureProps) {
  // WebViewGold iOS and Safari iOS/iPad users always have access (App Store compliance)
  if (shouldBypassSubscription()) {
    return <>{children}</>;
  }

  const { isSubscribed, isLoading, checkAccess } = useSubscription();
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [hasAccess, setHasAccess] = useState(true); // Changed to true to avoid showing overlay

  // Check subscription status when component mounts
  useEffect(() => {
    const verifyAccess = async () => {
      const access = await checkAccess();
      console.log(`Access check for ${featureName}:`, access);
      // We're not setting hasAccess to false anymore since we're using the crown icon approach
      // setHasAccess(access);
    };
    
    verifyAccess();
  }, [checkAccess, featureName]);
  
  if (isLoading) {
    return (
      <div className="relative min-h-[200px] flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-amber-600 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  return (
    <div className="relative">
      {children}
            
      <SubscriptionModal
        isOpen={showSubscriptionModal}
        onClose={() => setShowSubscriptionModal(false)}
      />
    </div>
  );
}